import { useContext, useEffect } from 'react';
import { PageLoadingContext } from '@/state/contexts';

/**
 * Hook to manage page-level loading state.
 *
 * Automatically shows the HeartLoader in the Layout when loading is true,
 * and resets to false when the component unmounts.
 *
 * @example
 * // With RTK Query
 * const { data, isLoading } = useGetStudyQuery(uuid);
 * usePageLoading(isLoading);
 *
 * @example
 * // With multiple loading states
 * const { isLoading: loadingStudy } = useGetStudyQuery(uuid);
 * const { isLoading: loadingAssignments } = useGetAssignmentsQuery(params);
 * usePageLoading(loadingStudy || loadingAssignments);
 */
export function usePageLoading(isLoading: boolean) {
  const { setPageLoading } = useContext(PageLoadingContext);

  useEffect(() => {
    setPageLoading(isLoading);
  }, [isLoading, setPageLoading]);

  useEffect(
    () => () => {
      setPageLoading(false);
    },
    [setPageLoading]
  );
}
